
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { persistor } from "app/store";
import { isImageUrlExpiredOrInvalid } from "utils/commonUtils";
import { getUserData } from "api/authApi";
import { logout, setUser } from "states/auth/authSlice";


const useFetchUserData = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    const {
        user,
        token,
    } = useSelector((state) => state.auth);


    const handleLogOutPress = useCallback(async () => {
        localStorage.removeItem("currentStep");
        try {
            await dispatch(logout());
            persistor.purge(); // Clear the persisted state safely
            navigate("/");
        } catch (error) {
            console.error("Logout failed", error);
        }
    }, [dispatch, navigate]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let needNewProfileImage = false;

                if (user?.brand) {
                    if (
                        !user.brand.profile_image ||
                        // isImageUrlExpiredOrInvalid(user.brand.profile_image) ||
                        isImageUrlExpiredOrInvalid(user.brand.profile_image_thumb)
                    ) {
                        needNewProfileImage = true;
                    }
                } else if (user?.creator) {
                    if (
                        !user.creator.profile_image ||
                        // isImageUrlExpiredOrInvalid(user.creator.profile_image) ||
                        isImageUrlExpiredOrInvalid(user.creator.profile_image_thumb)
                    ) {
                        needNewProfileImage = true;
                    }
                }

                const dataUser = await getUserData(token, needNewProfileImage);

                if (user && dataUser?.username) {
                    let newUser = {
                        ...user,
                        account_verified: dataUser?.account_verified,
                        account_status: dataUser?.account_status,
                    };

                    // 🔹 1) Update avatar nếu cần
                    if (needNewProfileImage) {
                        if (dataUser?.brand && user.brand) {
                            newUser = {
                                ...newUser,
                                brand: {
                                    ...newUser.brand,
                                    profile_image: dataUser.brand.profile_image,
                                    profile_image_thumb: dataUser.brand.profile_image_thumb,
                                },
                            };
                        } else if (dataUser?.creator && user.creator) {
                            newUser = {
                                ...newUser,
                                creator: {
                                    ...newUser.creator,
                                    profile_image: dataUser.creator.profile_image,
                                    profile_image_thumb: dataUser.creator.profile_image_thumb,
                                },
                            };
                        }
                    }

                    // 🔹 2) Sync profile_complete (không phụ thuộc avatar)
                    if (dataUser?.brand && user.brand) {
                        newUser = {
                            ...newUser,
                            brand: {
                                ...newUser.brand,
                                profile_complete: dataUser.brand.profile_complete,
                            },
                        };
                    } else if (dataUser?.creator && user.creator) {
                        newUser = {
                            ...newUser,
                            creator: {
                                ...newUser.creator,
                                profile_complete: dataUser.creator.profile_complete,
                            },
                        };
                    }

                    dispatch(setUser(newUser));
                }
            } catch (err) {
                console.log({ err });
                if (err?.response?.status === 401) {
                    handleLogOutPress();
                    toast.error("Your account needs to be logged in again.");
                }
            }
        };

        if (token) {
            fetchData();
        }
    }, [token,
        // pathname
    ]);
};

export default useFetchUserData;
